import { ContainerFlex } from '@app/components-legacy/Container'
import { Tooltip } from 'antd'
import type { TooltipProps } from 'antd/lib/tooltip'
import React from 'react'
import LabelSlicedContainer from './LabelSlicedContainer'
import type { ILabelSlicedProps } from './types'

/** @deprecated */
const LabelSlicedTooltipContent: React.FC<ILabelSlicedProps> = props => {
  const [isValueSliced, setIsValueSliced] = React.useState(!props.maxWidth)

  React.useEffect(() => {
    setIsValueSliced(!props.maxWidth)
  }, [props.value, props.maxWidth])

  const getTooltipContent = (): React.ReactNode => {
    const { maxWidth, ...labelProps } = props

    return (
      <ContainerFlex
        name="TooltipContent"
        direction="column"
        items={[
          <LabelSlicedContainer
            {...labelProps}
            maxLength={props.popoverMaxLength}
            breakString
          />,
          props.decoration
        ]}
        spaced
      />
    )
  }

  const tooltipProps: TooltipProps = {
    title: isValueSliced ? getTooltipContent() : null,
    open: isValueSliced ? undefined : false,
    ...props.tooltipProps
  }

  return (
    <Tooltip {...tooltipProps}>
      <span>
        <LabelSlicedContainer
          {...props}
          onEllipsisActiveChange={setIsValueSliced}
        />
      </span>
    </Tooltip>
  )
}

export default LabelSlicedTooltipContent
